module.exports = __webpack_public_path__ + "img/ic_32_workout_item_equipment.b087f0f6.svg";